import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-access-request-sent',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './access-request-sent.component.html',
})
export class AccessRequestSentComponent implements OnInit {
  private router = inject(Router);

  companyName = signal<string>('');
  email = signal<string>('');

  ngOnInit() {
    // Retrieve data from localStorage
    const storedCompanyName = localStorage.getItem('accessRequestCompanyName');
    const storedEmail = localStorage.getItem('accessRequestEmail');

    if (storedCompanyName && storedEmail) {
      this.companyName.set(storedCompanyName);
      this.email.set(storedEmail);
      // Clean up
      localStorage.removeItem('accessRequestCompanyName');
      localStorage.removeItem('accessRequestEmail');
    } else {
      // If no data, redirect to register
      this.router.navigate(['/auth/register']);
    }
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
